export default {"src":"/_next/static/media/v3-logo.4bf1fdc8.svg","height":104,"width":104,"blurWidth":0,"blurHeight":0};